module.exports = __webpack_public_path__ + "static/media/data.f92a2ae6.csv";